import { MARGHERITA_IMAGE, SALAMI_IMAGE, OVEN_IMAGE, HandUnderline, scrollToMenu } from "@/components/brand/BrandAssets";

const T = {
  aboutEyebrow: { lv: "Par mums", ru: "О нас", en: "About us" },
  aboutTitle: { lv: "Neapoles pica no malkas krāsns — tieši uz tavu galdu", ru: "Неаполитанская пицца прямиком из дровяной печи — прямо на ваш стол", en: "Neapolitan pizza straight from the wood-fired oven — to your table" },
  about: {
    lv: [
      "Roze di Napoli ir Neapoles pica tepat Liepājā. Mēs cepam malkas krāsnī un piegādājam tieši uz tavām mājām vai sagatavojam līdzņemšanai — bez zāles, bez steigas, ar visu uzmanību picai.",
      "Dažreiz pietiek ar klasiku: tomātu mērce, mozzarella un baziliks. Citreiz gribas atklāt jaunu garšu vai dalīties ar vairākām picām visai kompānijai.",
      "Izvēlies savu iecienītāko, pasūti dažos klikšķos — un vakars var sākties.",
    ],
    ru: [
      "Roze di Napoli — неаполитанская пицца здесь, в Лиепае. Мы печём в дровяной печи и доставляем прямо к вам домой или готовим к самовывозу — без зала, без спешки, со всем вниманием к пицце.",
      "Иногда достаточно классики: томатный соус, моцарелла и базилик. А иногда хочется открыть новый вкус или разделить несколько пицц на всю компанию.",
      "Выбирайте любимую, заказывайте в пару кликов — и вечер может начинаться.",
    ],
    en: [
      "Roze di Napoli is Neapolitan pizza right here in Liepāja. We bake in a wood-fired oven and deliver straight to your home or have it ready for pickup — no dining room, no rush, all attention on the pizza.",
      "Sometimes the classic is enough: tomato sauce, mozzarella and basil. Other times you want to discover a new flavour or share several pizzas with the whole group.",
      "Pick your favourite, order in a few clicks — and the evening can begin.",
    ],
  },
  doughAlt: { lv: "Neapoles pica tikko no malkas krāsns uz koka lāpstas", ru: "Неаполитанская пицца только что из дровяной печи на деревянной лопате", en: "Neapolitan pizza fresh from the wood-fired oven on a wooden peel" },
  menuEyebrow: { lv: "Ēdienkarte", ru: "Меню", en: "Menu" },
  menuTitle: { lv: "No Margherita līdz Salami", ru: "От Margherita до Salami", en: "From Margherita to Salami" },
  menu: {
    lv: [
      "No Margherita līdz Salami un Prosciutto Funghi — atrodi picu, kas piestāv tavam vakaram.",
      "Ēdienkartē ir arī calzone, panini, salāti un deserti. Izvēlies vienu sev vai pasūti visai kompānijai — piegādāsim visu kopā.",
    ],
    ru: [
      "От Margherita до Salami и Prosciutto Funghi — найди пиццу, которая подходит твоему вечеру.",
      "В меню также calzone, панини, салаты и десерты. Выбери что-то для себя или закажи на всю компанию — привезём всё вместе.",
    ],
    en: [
      "From Margherita to Salami and Prosciutto Funghi — find the pizza that suits your evening.",
      "The menu also has calzone, panini, salads and desserts. Choose one for yourself or order for the whole group — we deliver it all together.",
    ],
  },
  menuBtn: { lv: "Skatīt ēdienkarti", ru: "Смотреть меню", en: "View menu" },
  margheritaAlt: { lv: "Roze Margherita pica", ru: "Пицца Roze Margherita", en: "Roze Margherita pizza" },
  salamiAlt: { lv: "Roze Salami pica", ru: "Пицца Roze Salami", en: "Roze Salami pizza" },
  margheritaCap: { lv: "Margherita — tomāti, mozzarella, baziliks", ru: "Margherita — томаты, моцарелла, базилик", en: "Margherita — tomato, mozzarella, basil" },
  salamiCap: { lv: "Salami — tomāti, mozzarella, salami, olīvas", ru: "Salami — томаты, моцарелла, салями, оливки", en: "Salami — tomato, mozzarella, salami, olives" },
};

const Copy = ({ paragraphs, className = "" }) => (
  <div className={`font-display !font-medium text-[#44403C] space-y-6 max-w-[32rem] ${className}`}>
    {paragraphs.map((p, i) => (
      <p key={i} className={`m-0 ${i === 0 ? "text-[1.35rem] sm:text-[1.55rem] leading-[1.55] text-[#1C1917]" : "text-[1.15rem] sm:text-[1.3rem] leading-[1.7]"}`}>
        {p}
      </p>
    ))}
  </div>
);

const Figure = ({ src, alt, caption, ratio = "aspect-square", warm = false }) => (
  <figure className="m-0">
    <div className={`${ratio} overflow-hidden bg-[#F5F2EC] ${warm ? "rz-photo-warm" : ""}`}>
      <img src={src} alt={alt} loading="lazy" decoding="async" className="w-full h-full object-cover" />
    </div>
    {caption && <figcaption className="mt-4 text-[0.72rem] tracking-[0.18em] uppercase text-[#78716C]">{caption}</figcaption>}
  </figure>
);

const EditorialSections = ({ language }) => {
  const t = (k) => T[k][language] || T[k].lv;

  return (
    <div className="rz-page" data-testid="editorial-sections">
      {/* Par mums */}
      <section id="about-section" className="scroll-mt-20 max-w-[1400px] mx-auto px-5 sm:px-8 pt-24 sm:pt-36 pb-24 sm:pb-36" aria-labelledby="about-heading" data-testid="about-section">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          <div className="lg:col-span-5 lg:col-start-2">
            <p className="rz-eyebrow m-0 mb-6">{t("aboutEyebrow")}</p>
            <h2 id="about-heading" className="font-display text-[#1C1917] text-[clamp(2.2rem,5vw,3.9rem)] leading-[1.05] tracking-[-0.01em] m-0">
              {t("aboutTitle")}
            </h2>
            <HandUnderline className="mt-6 w-[140px]" />
            <Copy paragraphs={t("about")} className="mt-10" />
          </div>
          <div className="lg:col-span-5 lg:col-start-8">
            <Figure src={OVEN_IMAGE} alt={t("doughAlt")} ratio="aspect-[3/4]" />
          </div>
        </div>
      </section>

      {/* Ēdienkarte editorial */}
      <section className="bg-[#F5F2EC]" aria-labelledby="menu-heading" data-testid="menu-editorial-section">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 pt-24 sm:pt-32 pb-24 sm:pb-32">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-end">
            <div className="lg:col-span-5 lg:col-start-2">
              <p className="rz-eyebrow m-0 mb-6">{t("menuEyebrow")}</p>
              <h2 id="menu-heading" className="font-display text-[#1C1917] text-[clamp(2.2rem,5vw,3.9rem)] leading-[1.05] tracking-[-0.01em] m-0">
                {t("menuTitle")}
              </h2>
              <Copy paragraphs={t("menu")} className="mt-10" />
              <button onClick={scrollToMenu} className="rz-btn mt-12" data-testid="editorial-menu-button">
                {t("menuBtn")}
              </button>
            </div>
            <div className="lg:col-span-6 lg:col-start-7 grid grid-cols-2 gap-5 sm:gap-8">
              <div className="pt-12 sm:pt-20">
                <Figure src={MARGHERITA_IMAGE} alt={t("margheritaAlt")} caption={t("margheritaCap")} warm />
              </div>
              <Figure src={SALAMI_IMAGE} alt={t("salamiAlt")} caption={t("salamiCap")} warm />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EditorialSections;
